import ApplicantDetail from '@/controllers/applicant/applicant-detail.js';

export default {
  extends: ApplicantDetail,
}
